"use client";

import { openLeadPopup } from "@/utils/innovlistWidget";

export type EnrollButtonVariant = "primary" | "secondary" | "outline" | "white" | "ghost";
export type EnrollButtonSize = "sm" | "md" | "lg" | "xl";

export interface EnrollButtonProps {
  label?: string;
  variant?: EnrollButtonVariant;
  size?: EnrollButtonSize;
  context?: string;
  className?: string;
  icon?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
}

const VARIANTS: Record<EnrollButtonVariant, string> = {
  primary:
    "bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200",
  secondary:
    "bg-yellow-400 hover:bg-yellow-500 text-gray-900 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200",
  outline:
    "border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white rounded-lg font-semibold transition-all duration-200",
  white:
    "bg-white text-blue-600 hover:bg-gray-100 rounded-lg font-semibold shadow-md transition-all duration-200",
  ghost: "text-blue-600 hover:underline font-semibold transition-colors",
};

const SIZES: Record<EnrollButtonSize, string> = {
  sm: "text-sm px-4 py-2",
  md: "text-base px-6 py-3",
  lg: "text-lg px-8 py-4",
  xl: "text-xl px-10 py-5",
};

export default function EnrollButton({
  label = "Enroll Now",
  variant = "primary",
  size = "md",
  context = "default",
  className = "",
  icon = true,
  fullWidth = false,
  onClick = () => {},
}: EnrollButtonProps) {
  const handleClick = () => {
    openLeadPopup(context);
    onClick && onClick();
  };

  return (
    <button
      onClick={handleClick}
      className={[
        "inline-flex items-center justify-center",
        VARIANTS[variant] || VARIANTS.primary,
        SIZES[size] || SIZES.md,
        fullWidth ? "w-full" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      type="button"
      aria-label={label}
    >
      {label}
      {icon ? <span className="ml-2">-&gt;</span> : null}
    </button>
  );
}

